<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-22T23:15:13+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2018-06-13T15:29:42+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <section id="intro">
    <b-container class="pt-4">
      <b-row>
        <!-- expertise -->
        <b-col md="6">
          <h4 v-html="$t('intro.expert_title')" />
          <uli
            :nritems="4"
            color="info"
            icon="long-arrow-alt-right"
            outline
            button
            size="sm"
            labelkey="intro.list_expert"
          />
        </b-col>
        <!-- problems we solve -->
        <b-col md="6">
          <h4 v-html="$t('intro.problems_title')" />
          <uli
            :nritems="10"
            color="success"
            icon="plus"
            size="sm"
            labelkey="intro.problems_list"
            tooltipkey="intro.problems_tooltip"
          />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: 'Intro',
  data () {
    return {
      msg: 'Intro header part'
    }
  }
}
</script>

<style lang="scss" scoped>

  @import "../../assets/style/theme.scss";

  section#intro {
    #title {
      padding-bottom: 10px;
      h3 {
        display: inline-block;
        margin: 0;
        padding: 0;
      }
    }
    .subtitle {
      margin-bottom: 0.6em;;
    }
    .incentive {
      margin-top: 20px;
    }

  }

</style>
